<template>
  <div class="login-app">
    <router-link to="/console/app-list">
      <div class="button-back">
        <el-icon>
          <ArrowLeft />
        </el-icon>
        {{ $t('breadcrumb.back') }}
      </div>
    </router-link>
    <div class="form-login-container">
      <div class="left-content">
        <img src="@/assets/images/login-olsera-icon.png" class="logo-ols" />
      </div>
      <div class="right-content">
        <div class="title">{{ $t('login_olsera.title') }}</div>
        <div class="">
          <el-form
            ref="refForm"
            :model="formData"
            :rules="rules"
            label-position="top"
            @keyup.enter="doLogin"
            @submit.prevent>
            <el-form-item prop="email">
              <el-input v-model="formData.email" />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="formData.password"
                :type="passwordInput ? 'password' : 'text'">
                <template #append>
                  <div role="button" class="pointer" @click="passwordInput = !passwordInput">
                    <i :class="passwordInput ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" class="btn-full-block" @click="doLogin">
                Masuk
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ArrowLeft } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const store = useStore()
const router = useRouter()
const loading = ref(false)
const refForm = ref(null)
const formData = ref({
  password: '',
  email: ''
})
const passwordInput = ref(true)
const rules = reactive({
  password: [{ required: true, trigger: 'blur' }],
  email: [{ required: true, type: 'email', trigger: 'blur' }]
})
const doLogin = () => {
  if (!refForm.value) return
  refForm.value.validate((valid) => {
    if (valid) {
      loading.value = true
      store.dispatch('app/fetchOlseraToken', formData.value).then(() => {
        router.push({
          path: '/console/app-list'
        })
        ElMessage({
          type: 'success',
          message: t('login_olsera.login_success')
        })
        loading.value = false
      }).catch((error) => {
        ElMessage({
          type: 'error',
          message: error.message
        })
        loading.value = false
      })
    } else {
      ElMessage({
        type: 'warning',
        message: 'Silakan Lengkapi data'
      })
      loading.value = false
      return false
    }
  })
}
</script>
